//用于存放改变数据的方法名字,便于调用
export const SET_USERID = 'SET_USERID'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_PRODUCTID = 'SET_PRODUCTID'
export const SET_VIDEOID = 'SET_VIDEOID'
export const SET_CHANNELTYPE = 'SET_CHANNELTYPE'
export const SET_OPERDIR = 'SET_OPERDIR'
export const SET_CHANNELLIST = 'SET_CHANNELLIST'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js